import Title from "../components/TheTitle.vue";
import PointInfo from "../components/PointInfo.vue";
import PointSetting from "../components/PointSetting.vue";
import { Validation } from "../utils/validation";
import { getBrandsMaster, getStoresMaster, searchUser, bulkGrantPoint, usePoint, } from "../api";
import { FormatDate } from "../utils/formatDate";
import { Authorize } from "../utils/authorize";
export default {
    name: "PointGrantResult",
    data() {
        return {
            brandInfo: [],
            storeInfo: [],
            pointItem: null,
            tableInfo: [],
            pageSize: 100,
            infoPage: 1,
            pointBulkGrantHistoryId: "",
            show: false,
            form: {
                customerId: "",
                phone: "",
                name: "",
                brand: "",
                store: "",
                dateFrom: "",
                dateTo: "",
            },
            pointBulkGrantInfo: null,
            //保留情報
            selectedRows: [],
            grantDialogVisible: false,
            granting: false,
            imported: false,
        };
    },
    components: {
        Title,
        PointInfo,
        PointSetting,
    },
    computed: {
        infoTotalPages() {
            return Math.max(1, Math.ceil(this.tableInfo.length / this.pageSize));
        },
        pagedInfo() {
            const start = (this.infoPage - 1) * this.pageSize;
            return this.tableInfo.slice(start, start + this.pageSize);
        },
    },
    watch: {
        // データが変更されたらページを先頭に戻す
        info() {
            this.infoPage = 1;
        },
        "$store.state.pointSetting": {
            handler(newVal) {
                if (newVal) {
                    this.pointItem = {
                        ...newVal,
                        brand: newVal.brand.brandName,
                        store: newVal.store.storeName,
                        publisher: this.$store.state.displayName,
                    };
                    this.pointBulkGrantInfo = {
                        point_type: "OPS",
                        point_name: newVal.point_name,
                        point_grant_reason: newVal.point_grant_reason,
                        grant_point: Number(newVal.points),
                        effective_period_date: Number(newVal.effective_period_date),
                        issue_brand_id: newVal.brand.brandId,
                        issue_brand: newVal.brand.brandName,
                        issue_store_id: newVal.store.storeId,
                        issue_store: newVal.store.storeName,
                        publisher: this.$store.state.displayName,
                    };
                }
            },
            immediate: true,
        },
        "form.brand": async function (newBrand) {
            if (!newBrand) {
                this.storeInfo = [];
                this.form.store = "";
                return;
            }
            try {
                const response = await getStoresMaster(newBrand); // brandId を直接渡す
                if (response.result?.code === 9) {
                    this.$store.commit("setMessages", response.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    this.storeInfo = response.data.results || [];
                    // 選択中の store が新しい storeInfo に存在しない場合はクリアする
                    if (!this.storeInfo.find((s) => s.storeId === this.form.store)) {
                        this.form.store = "";
                    }
                }
            }
            catch (err) {
                console.error(err);
            }
        },
    },
    methods: {
        openModal() {
            this.show = true;
        },
        closeModal() {
            this.show = false;
        },
        setInfoPage(p) {
            if (p < 1)
                p = 1;
            if (p > this.infoTotalPages)
                p = this.infoTotalPages;
            this.infoPage = p;
        },
        goCsvUpload() {
            this.$router.push("/csvImport").catch(() => {
                /* NavigationDuplicated 等のエラーを無視 */
            });
        },
        toggleSelectAll() {
            // 表示中のみ切替ではなく、全件を対象にするか表示中のみかを切替えたい場合は別ボタンを用意する
            const allIds = this.tableInfo.map((r) => r.crm_customer_id);
            const allSelected = allIds.every((id) => this.selectedRows.includes(id));
            if (allSelected) {
                // 全解除
                this.selectedRows = [];
            }
            else {
                // 全選択（重複除去）
                this.selectedRows = Array.from(new Set([...this.selectedRows, ...allIds]));
            }
        },
        formatDate(value) {
            return FormatDate.withoutTime(value);
        },
        async onSearch() {
            const brandName = this.form.brand && this.brandInfo
                ? (this.brandInfo.find((b) => b.brandId === this.form.brand) ||
                    {}).brandName || null
                : null;
            const storeName = this.form.store && this.storeInfo
                ? (this.storeInfo.find((s) => s.storeId === this.form.store) ||
                    {}).storeName || null
                : null;
            const params = {
                crm_customer_ids: [this.form.customerId || ""],
                mobile_phone_number: (this.form.phone || null),
                name: (this.form.name || null),
                last_use_brand: (brandName || null),
                last_use_store: (storeName || null),
                last_use_at_from: (this.form.dateFrom || null),
                last_use_at_to: (this.form.dateTo || null),
            };
            const errorMessage = this.validate(params);
            if (errorMessage) {
                this.$store.commit("setMessages", errorMessage);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const response = await searchUser(params.crm_customer_ids, params.mobile_phone_number, params.name, params.last_use_brand, params.last_use_store, params.last_use_at_from, params.last_use_at_to);
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.tableInfo = response.data.results;
                this.infoPage = 1;
                if (this.imported) {
                    this.selectedRows = [];
                    this.imported = false;
                }
            }
        },
        validate(params) {
            // エラーメッセージを格納する配列
            const errors = [];
            // 桁数チェック
            if (params.crm_customer_ids.length) {
                errors.push(...Validation.digitsMax({
                    key: "顧客ID",
                    value: params.crm_customer_ids[0],
                }, 20));
            }
            errors.push(...Validation.digitsMax({
                key: "電話番号",
                value: params.mobile_phone_number,
            }, 13));
            errors.push(...Validation.digitsMax({
                key: "氏名",
                value: params.name,
            }, 100));
            if (params.last_use_at_from &&
                params.last_use_at_to &&
                params.last_use_at_to < params.last_use_at_from) {
                errors.push("最終利用日のFromとToは、FromがToより小さくなるように入力してください。");
            }
            if (errors.length > 0) {
                return errors;
            }
            return "";
        },
        onClear() {
            this.form = {
                customerId: "",
                phone: "",
                name: "",
                brand: "",
                store: "",
                dateFrom: "",
                dateTo: "",
            };
        },
        onGrantClick() {
            if (!this.pointItem) {
                this.$store.commit("setMessages", ["ポイント設定後、付与が可能です。"]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            const isDeduction = Number(this.pointBulkGrantInfo?.grant_point) < 0;
            if (isDeduction && this.selectedRows.length > 1) {
                this.$store.commit("setMessages", [
                    "ポイント減算は対象者を1名に絞って実行してください。",
                ]);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
                return;
            }
            this.executeGrant();
        },
        async executeGrant() {
            if (this.granting)
                return;
            this.granting = true;
            const isDeduction = Number(this.pointBulkGrantInfo?.grant_point) < 0;
            try {
                if (isDeduction) {
                    await this.executeDeduct();
                }
                else {
                    await this.executeBulkGrant();
                }
            }
            finally {
                this.granting = false;
            }
        },
        async executeBulkGrant() {
            try {
                const rspBody = await bulkGrantPoint(this.selectedRows, this.pointBulkGrantInfo);
                if (rspBody.result.code === 9) {
                    if (rspBody.result.messages) {
                        this.$store.commit("setMessages", rspBody.result.messages);
                        this.$store.commit("setCancelBtnHide", true);
                        this.$store.commit("setIsModalOpen", true);
                    }
                }
                else {
                    const id = rspBody.data.point_bulk_grant_history_id;
                    this.selectedRows = [];
                    this.$store.commit("clearPointSetting");
                    this.$router.push(`/pointGrantResult/${id}`).catch(() => {
                        /* NavigationDuplicated 等のエラーを無視 */
                    });
                }
            }
            catch (err) {
                console.error(err);
                alert("ポイント付与に失敗しました。");
            }
        },
        async executeDeduct() {
            try {
                const crm_customer_id = this.selectedRows[0];
                const use_points = Math.abs(Number(this.pointBulkGrantInfo.grant_point));
                const rspBody = await usePoint({
                    crm_customer_id,
                    point_type: this.pointBulkGrantInfo.point_type,
                    use_points,
                    is_admin: true,
                });
                if (rspBody.result.code === 9) {
                    this.$store.commit("setMessages", rspBody.result.messages);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
                else {
                    const actualPoint = rspBody.data.use_point;
                    this.selectedRows = [];
                    this.$store.commit("clearPointSetting");
                    this.$store.commit("setMessages", [
                        `${crm_customer_id} から ${actualPoint} ポイントを減算しました。`,
                    ]);
                    this.$store.commit("setCancelBtnHide", true);
                    this.$store.commit("setIsModalOpen", true);
                }
            }
            catch (err) {
                console.error(err);
                alert("ポイント減算に失敗しました。");
            }
        },
    },
    async mounted() {
        if (await Authorize.isExpired(this)) {
            // CSVインポート値取得
            if (this.$store.state.csvMatched) {
                this.tableInfo = this.$store.state.csvMatched;
                this.$store.commit("clearCsvMatched");
                const allIds = this.tableInfo.map((r) => r.crm_customer_id);
                this.selectedRows = Array.from(new Set([...this.selectedRows, ...allIds]));
                this.imported = true;
            }
            const response = await getBrandsMaster("OPS");
            if (response.result?.code === 9) {
                this.$store.commit("setMessages", response.result.messages);
                this.$store.commit("setCancelBtnHide", true);
                this.$store.commit("setIsModalOpen", true);
            }
            else {
                this.brandInfo = response.data.results;
            }
        }
    },
};
